import { Link } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import { Button } from '@reflex/ui/components/ui/button';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import { ActionRow } from '@reflex/ui/components/shared/ActionRow';
import type { PluginSecretStatus } from '@/lib/plugin-registry';
import { pluginServiceSecretsHref } from '@/lib/routes';
import { SecretBadge } from './SecretBadge';

function isServiceTier(secret: PluginSecretStatus): boolean {
  return secret.tier === 'service';
}

export function PluginSecretsSection({
  secrets,
  pluginName,
}: {
  secrets: PluginSecretStatus[];
  pluginName: string;
}) {
  if (secrets.length === 0) return null;

  const serviceSecretsHref = pluginServiceSecretsHref(pluginName);

  return (
    <section data-testid="plugin-detail-section-secrets">
      <IconSectionHeader icon={KeyRound}>Required Secrets</IconSectionHeader>
      <div className="divide-y rounded-lg border">
        {secrets.map((s) => (
          <ActionRow
            key={s.key}
            data-testid={`plugin-secret-row-${s.key}`}
            title={<code className="font-mono text-sm">{s.key}</code>}
            description={s.description}
            actions={
              <>
                <SecretBadge secret={s} />
                {isServiceTier(s) && (
                  <Button asChild variant="outline" size="sm">
                    <Link to={serviceSecretsHref} data-testid={`plugin-secret-link-${s.key}`}>
                      {s.fulfilled ? 'Manage' : 'Set up'}
                    </Link>
                  </Button>
                )}
              </>
            }
          />
        ))}
      </div>
    </section>
  );
}
